// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--4ce81";
export var hero__container = "hero-module--hero__container--b3b13";
export var hero__header = "hero-module--hero__header--a8860";
export var hero__headerBtn = "hero-module--hero__header-btn--21233";
export var hero__headerLeft = "hero-module--hero__header-left--22b54";
export var hero__headerList = "hero-module--hero__header-list--1ae38";
export var hero__headerListItem = "hero-module--hero__header-list--item--d68e2";
export var hero__headerListLink = "hero-module--hero__header-list--link--a7beb";
export var hero__headerLogo = "hero-module--hero__header-logo--9aae9";
export var hero__headerLogoImg = "hero-module--hero__header-logo--img--f18a8";
export var hero__headerNav = "hero-module--hero__header-nav--63e14";
export var hero__headerNavIsClosed = "hero-module--hero__header-nav--is-closed--283e2";
export var hero__headerNavIsOpened = "hero-module--hero__header-nav--is-opened--fc445";
export var hero__headerTel = "hero-module--hero__header-tel--3c8d5";
export var hero__headerWrapper = "hero-module--hero__header-wrapper--6e64b";
export var hero__imageWrapper = "hero-module--hero__image-wrapper--89089";
export var hero__imgContainer = "hero-module--hero__img-container--aded4";
export var hero__infoColSecond = "hero-module--hero__info-col--second--994af";
export var hero__infoWrapper = "hero-module--hero__info-wrapper--a0bb8";
export var hero__item = "hero-module--hero__item--e4b15";
export var hero__linkWrapper = "hero-module--hero__link-wrapper--9bf68";
export var hero__list = "hero-module--hero__list--7a225";
export var hero__text = "hero-module--hero__text--02424";
export var hero__title = "hero-module--hero__title--9c08e";
export var hero__titleLarge = "hero-module--hero__title-large--0e2b8";
export var hero__titleWrapper = "hero-module--hero__title-wrapper--6967d";
export var navClose = "hero-module--nav-close--79ec0";
export var navOpen = "hero-module--nav-open--344c9";